import HeaderDesktop1 from './1/component';
import HeaderDesktop2 from './2/component';
import HeaderDesktop3 from './3/component';

const templates = {
	1: HeaderDesktop1,
	2: HeaderDesktop2,
	3: HeaderDesktop3,
};

export default templates;
export function HeaderDesktop(templateId = 1) {
	return templates[templateId]();
}
